import React, { useState, useEffect } from 'react';
//import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [active, setActive] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [staticBackgroundScrollPos, setStaticBackgroundScrollPos] = useState(200);
  
  const handleNavClick = () => {
    setActive(false);
  };

  const handleScroll = () => {
    if (window.scrollY > staticBackgroundScrollPos) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > staticBackgroundScrollPos) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, setStaticBackgroundScrollPos]);
  


  return (
    <div className={`Navbar-cmp ${scroll ? 'scroll' : ''}`}>
      <span className="nav-logo">
        <a href="/">
      <img src={scroll ? 'sevenlogo2.png' : 'greenlogo.png'} alt="" />
      </a>
      </span>

      <div className={`navbar-items ${active && 'switch'}`}>
        <a href="/" className='a-link' onClick={handleNavClick}>
          Home
        </a>
        <a href="/#about" className='a-link' onClick={handleNavClick}>
          About
        </a>
        <a href="/#courses" className='a-link' onClick={handleNavClick}>
          Courses
        </a>
        <a href="/#events" className='a-link' onClick={handleNavClick}>
          Events
        </a>
        <a href="/#blog" className='a-link' onClick={handleNavClick}>
          Blog
        </a>
        <a href="/#contact" className='a-link' onClick={handleNavClick}>
          Contact
        </a>
        <a href='/account' className='section-btn'> Sign In</a>
      </div>

      <div
        className={`nav-toggle ${active && 'switch'}`}
        onClick={() => setActive(!active)}
      >
        <div className="hamburger"></div>
      </div>
    </div>
  );
};

export default Navbar;
